import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import { PR_STATUS, fmtQty, prApi } from '@/services/prApi';

/** Requisitions of the same FG still to order (other than this one) — shown while a new requisition line is made. */
export const PendingForFg = ({ fg, excludePrId, idx }) => {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    let live = true;
    setRows([]);
    if (fg) prApi.pendingByFg([fg], excludePrId).then((p) => live && setRows(p[fg] || [])).catch(() => {});
    return () => { live = false; };
  }, [fg, excludePrId]);
  if (!rows.length) return null;
  const total = rows.reduce((t, r) => t + (Number(r.balance_qty) || 0), 0);
  return (
    <div className="mt-2 rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-900" data-testid={`pr-pending-fg-${idx}`}>
      <p className="mb-1 flex items-center gap-1 font-semibold"><AlertTriangle className="h-3.5 w-3.5" />
        {fg} is already pending on {rows.length} requisition{rows.length === 1 ? '' : 's'} — {fmtQty(total)} {rows[0].unit} still to order</p>
      <ul className="space-y-0.5">{rows.map((r) => (
        <li key={r.pr_item_id} data-testid={`pr-pending-fg-row-${r.pr_item_id}`}>
          <Link to={`/pr/${r.pr_id}`} target="_blank" className="font-mono font-medium text-indigo-700 hover:underline">{r.pr_number}</Link>
          {' '}· {r.section_name} · {(PR_STATUS[r.status] || [r.status])[0]} · {fmtQty(r.balance_qty)} of {fmtQty(r.required_qty)} {r.unit} to order
          {r.required_by_date ? ` · needed by ${r.required_by_date}` : ''}{r.created_by_name ? ` · ${r.created_by_name}` : ''}</li>))}</ul>
    </div>
  );
};

export default PendingForFg;
